import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import { useTranslation } from "react-i18next";
import { DatePicker, Select, Table, TableColumnsType } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { ITreeCode, ITreeSubcode } from "../../../../models/treeCodes.model";
import FileUpload from "../../../FileUpload";
import Button from "../../../Button";
import moment from "moment";
import useNotification from "../../../../hooks/useNotification";
import useAxios from "../../../../hooks/useAxios";
import { createExpense, getApprovalLine, getExpense } from "../../../../api/financials.api";
import { IResponse } from "../../../../models/common.api.model";
import { ApprovalLineType, ExpensePageType } from "../../../../constans";
import ErrorResponse from "../../../ErrorResponse";
import { IApprovalLine, IClient, IEmployeeValue, IGetExpense, IGetExpenseLine } from "../../../../models/financials.model";
import ClientManageModal from "../modals/ClientManageModal";
import update from 'immutability-helper';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ApprovalLineModal from "../modals/ApprovalLineModal";
import CCLineModal from "../modals/ApprovalLineModal";
import { ISubcode } from "../../../../models/codes.model";
import { financialsDefCCMemCode } from "../../../../lib/data";

interface DraggableBodyRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    index: number;
    moveRow: (dragIndex: number, hoverIndex: number) => void;
}

interface IProps {
    getExpenseList: (listType: 'A' | 'P') => void;
    setSelectedRow: (expenseCode: any) => void;
    setPageType: (param: ExpensePageType) => void;
    commonCode: string,
    expenseCode?: number;
}

const ExpenseCopy = ({getExpenseList, setSelectedRow, setPageType, commonCode, expenseCode} : IProps) => {

    const { t, i18n } = useTranslation();
    
    const { data: res, isLoading, error, execute } = useAxios<IResponse<Number>>();
    const { data: expenseCopyDetail, isLoading:copyLoading, error:copyError, execute: executeDetail } = useAxios<IGetExpense>();
    const { data: expenseLine, isLoading : loading2, error : lineError, execute: executeLine } = useAxios<IGetExpenseLine>();
    
    const { infoNotification, successNotification } = useNotification();
    const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
    const { treeCodes } = useSelector((state: RootState) => state.treeCodeData);
    // FA0001 = 지출 코드
    const FA0001 = treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 1));
    
    const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    // FA0002 = 지출방법
    const FA0002 = commonCodes.find(item => item.commonCode === 'FA0002')?.detailCode;
    // FA0003 = 지출여부
    const FA0003 = commonCodes.find(item => item.commonCode === 'FA0003')?.detailCode;
    // FA0004 = 증빙유형
    const FA0004 = commonCodes.find(item => item.commonCode === 'FA0004')?.detailCode;
    // FB0004 = 통화
    const FB0004 = commonCodes.find(item => item.commonCode === 'FB0004')?.detailCode;
    // SY0007 = 은행
    const SY0007 = commonCodes.find(item => item.commonCode === 'SY0007')?.detailCode;
    // FA0007 = 결재라인 기본값
    const FA0007 = commonCodes.find(item => item.commonCode === 'FA0007')?.detailCode;
    // FA0008 = 수신참조 기본값
    const FA0008 = commonCodes.find(item => item.commonCode === 'FA0008')?.detailCode;
    
    const [account1, setAccount1] = useState<string>();
    const [account2, setAccount2] = useState<string>();
    const [account3, setAccount3] = useState<string>();
    const [account2List, setAccount2List] = useState<ITreeSubcode[]>();
    const [account3List, setAccount3List] = useState<ITreeSubcode[]>();
    const type = 'DraggableBodyRow';
    const registDate = moment(new Date());  //작성일
    const [expenseDate, setExpenseDate] = useState('');   //지출일
    const [expenseMtd, setExpenseMtd] = useState("ON"); //지출방법
    const [expenseYn, setExpenseYn] = useState("Y");   //입금여부
    const [title, setTitle] = useState('');   //제목
    const [summary, setSummary] = useState('');   //적요
    const [currency, setCurrency] = useState("KRW");    //통화
    //const [clientCode, setClientCode] = useState('');
    const [clientName, setClientName] = useState('');
    const [clientDepositor, setClientDepositor] = useState('');
    const [clientTelNo, setClientTelNo] = useState('');
    const [clientBankCode, setClientBankCode] = useState<string | undefined>();
    const [clientAccNo, setClientAccNo] = useState('');
    const [proofType, setProofType] = useState('01');
    const [proofDate, setProofDate] = useState('');
    const [amount, setAmount] = useState(0);    //금액
    const [note, setNote] = useState('');   //비고
    // 신규 첨부파일
    const [files, setFiles] = useState<any>([null]);
    //결재라인
    const [selectedApprovalList, setSelectedApprovalList] = useState<Map<string, IEmployeeValue>>(new Map<string, IEmployeeValue>());
    const [approvalListData, setApprovalListData] = useState<any>([]);
    //수신참조
    const [selectedCCList, setSelectedCCList] = useState<Map<string, IEmployeeValue>>(new Map<string, IEmployeeValue>());
    const [ccListData, setCCListData] = useState<any>();

    const [vislbleClientModal, setVisibleClientModal] = useState(false);
    const [visibleApprovalLineModal, setVisibleApprovalLineModal] = useState(false);
    const [visibleCCLineModal, setVisibleCCLineModal] = useState(false);
    const dateArea = useRef<any>();

    useEffect(() => {
        if(expenseCode) {
            executeDetail(getExpense(expenseCode, commonCode));
            executeLine(getApprovalLine(expenseCode));
        }
    }, [expenseCode]);

    useEffect(() => {
        //조회되면 값 셋팅
        if(expenseCopyDetail?.data) {
            setAccount1(expenseCopyDetail.data.firstExpenseAccCode);
            setAccount2(expenseCopyDetail.data.secondExpenseAccCode);
            setAccount3(expenseCopyDetail.data.thirdExpenseAccCode);
            setAccount2List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 2 && item.parentDetailCode === Number(expenseCopyDetail.data.firstExpenseAccCode) )))
            setAccount3List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 3 && item.parentDetailCode === Number(expenseCopyDetail.data.secondExpenseAccCode) )))
            setExpenseDate(expenseCopyDetail.data.expenseDate);
            setExpenseMtd(expenseCopyDetail.data.expenseMtd);
            setExpenseYn(expenseCopyDetail.data.expenseYn);
            setTitle(expenseCopyDetail.data.title);
            setSummary(expenseCopyDetail.data.summary);
            setCurrency(expenseCopyDetail.data.currency);
            setAmount(expenseCopyDetail.data.amount);
            setNote(expenseCopyDetail.data.note);
            //setClientCode(expenseCopyDetail.data.clientCode);
            setClientName(expenseCopyDetail.data.clientName);
            setClientDepositor(expenseCopyDetail.data.clientDepositor);
            setClientTelNo(expenseCopyDetail.data.clientTelNo);
            setClientBankCode(expenseCopyDetail.data.clientBankCode);
            setClientAccNo(expenseCopyDetail.data.clientAccNo);
            setProofType(expenseCopyDetail.data.proofType);
            setProofDate(expenseCopyDetail.data.proofDate);
        }
    }, [expenseCopyDetail]);

    useEffect(() => {
        const appFinal : Map<string, IEmployeeValue> = new Map<string, IEmployeeValue>();
        const ccFinal : Map<string, IEmployeeValue> = new Map<string, IEmployeeValue>();

        if(expenseLine?.data) {
            expenseLine?.data.forEach((item) => {
                const memberCode = item.memberCode;
                const campusName = item.campusName
                const memberName = item.memberName + '(' + item.memberEngName + ')';
                if(item.lineType === ApprovalLineType.APPROVAL_LINE) {
                    let tempGroupName = getDefualtGroupName(FA0007, memberCode, campusName);
                    appFinal.set(memberCode, {campusCode:item.campusCode, campusName:tempGroupName, memberName:memberName});
                } else if(item.lineType === ApprovalLineType.CC_LINE) {
                    let tempGroupName = getDefualtGroupName(FA0008, memberCode, campusName);
                    ccFinal.set(memberCode, {campusCode:item.campusCode, campusName:tempGroupName, memberName:memberName});
                }
            });
        }

        setSelectedApprovalList(appFinal);
        setSelectedCCList(ccFinal);
    },[expenseLine]);

    useEffect(() => {
        let tempAppList : any = [];
        
        let orderSeq = 1;
        selectedApprovalList.forEach((value, key) => {
            tempAppList.push({campusCode:value.campusCode, memberCode:key, orderSeq:orderSeq, campusName:value.campusName, memberName:value.memberName})
            orderSeq++;
        });
        
        setApprovalListData(tempAppList);
    },[selectedApprovalList]);

    useEffect(() => {
        let tempAppList : any = [];
        
        let orderSeq = 1;
        selectedCCList.forEach((value, key) => {
            tempAppList.push({campusCode:value.campusCode, memberCode:key, orderSeq:orderSeq, campusName:value.campusName, memberName:value.memberName})
            orderSeq++;
        });
        
        setCCListData(tempAppList);
    },[selectedCCList]);

    useEffect(() => {
        if(res) {
            if(res.result === "success") {
                successNotification(t('common.message.save1'));
                //리스트페이지 검색조건으로 재검색
                getExpenseList('A');
                //조회페이지로 변경
                setPageType(ExpensePageType.VIEW);
                setSelectedRow(res.data);
            }
        }
    }, [res]);

    //기본 참조,결재자 그룹명(직책) 변경
    const getDefualtGroupName = (lineList : ISubcode[] | undefined, memberCode : string, groupName : string) => {
        let tempGroupName = groupName;
        if(lineList && lineList.length > 0) {
            lineList.map((item) => {
                if(item.detailCode === memberCode) {
                    if(item.korName.indexOf('|') > -1 &&  item.engName.indexOf('|') > -1) {
                        tempGroupName = item.korName.split('|')[1];
                    }
                }
                return item;
            });
        }
        return tempGroupName;
    }

    const firstAccountChange = (value : any) => {
        setAccount1(value);
        if(value) {
            setAccount2List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 2 && item.parentDetailCode === Number(value) )))
            setAccount3List(undefined);
            setAccount2(undefined);
            setAccount3(undefined);
        }
    }

    const secondAccountChange = (value : any) => {
        setAccount2(value);
        if(value) {
            setAccount3(undefined);
            setAccount3List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 3 && item.parentDetailCode === Number(value) )));
        }
    }

    const onSetFile = (index: number, file: any) => {
        const _files = [...files];
        _files[index] = file;
        setFiles(_files);
    }

    const onAddFile = () => {
        const _files = [...files];
        _files.push(null);
        setFiles(_files);
    }

    const onDeleteFile = (index: number) => {
        const _files = [...files];
        _files.splice(index, 1);
        setFiles(_files);
    }

    const onSave = async () => {
        if(!account3) {
            return infoNotification(t('payment.income.msg2'));
        }

        if(!expenseDate) {            
            return infoNotification(t('payment.expense.msg1'));
        }
        
        if(!title) {            
            return infoNotification(t('payment.expense.msg2'));
        }

        if(!amount) {            
            return infoNotification(t('payment.income.msg5'));
        }

        if(!proofDate) {
            return infoNotification(t('payment.expense.msg3'));
        }

        //파라미터 셋팅(form)
        const form = new FormData();
        //결재라인 campusCheck
        const campusCodeCheck : Set<string> = new Set<string>();
        //결재라인
        if (approvalListData.length > 0) {
            approvalListData.forEach((item: any) => {
                if (item !== null) {
                    form.append('approvalLine', item.memberCode);
                    campusCodeCheck.add(item.campusCode);
                }
            });
        }
        //수신참조
        if (ccListData.length > 0) {
            ccListData.forEach((item: any) => {
                if (item !== null) {
                    form.append('ccLine', item.memberCode);
                    campusCodeCheck.add(item.campusCode);
                }
            });
        }

        if(campusCodeCheck.size > 2) {
            return infoNotification(t('payment.expense.msg9'));
        }

        form.append('campusCode', currentCampus);   //auth.hqYn === 'Y' auth.campus[0]
        form.append('expenseAccCode', account3);
        form.append('registDate', registDate.format('YYYYMMDD'));
        form.append('expenseDate', expenseDate);
        form.append('expenseMtd', expenseMtd);
        form.append('expenseYn', expenseYn);
        form.append('title', title);
        form.append('summary', summary);
        /*  거래처코드는 추후 필요 시 입력 
        if(!clientCode) {
            form.append('clientCode', clientCode);
        }
        */
        form.append('clientName', clientName);
        form.append('clientDepositor', clientDepositor);
        form.append('clientTelNo', clientTelNo);
        form.append('clientBankCode', (clientBankCode) ? clientBankCode : '');
        form.append('clientAccNo', clientAccNo);
        form.append('proofType', proofType);
        form.append('proofDate', proofDate);
        form.append('currency', currency);
        form.append('amount', amount.toString());
        form.append('note', note);
        if (files.length > 0) {
            files.forEach((item: any) => {
                if (item !== null) form.append('files', item);
            });
        }

        execute(createExpense(form));
    }

    const fnSetClientInfo = (clientInfo : IClient) => {
        //setClientCode(clientInfo.clientCode);
        setClientName(clientInfo.clientName);
        setClientDepositor(clientInfo.depositor);
        setClientTelNo(clientInfo.telNo);
        setClientBankCode(clientInfo.bankCode);
        setClientAccNo(clientInfo.accountNo);
    }

    const delMember = (lineList: Map<string, IEmployeeValue>, setLineList: (lineList: Map<string, IEmployeeValue>)=>void , delMemberCode : string) => {
        let tempData = new Map<string, IEmployeeValue>(lineList?.entries());
        tempData.delete(delMemberCode);
        setLineList(tempData);
    }

    const appLinecolumns: TableColumnsType<IApprovalLine> = [
        {
            title: t('system.menu.column1'),
            dataIndex: 'orderSeq',
            key: 'orderSeq',
            align: 'center',
        },
        {
            title: t('campus.staff.column38'),
            dataIndex: 'campusName',
            key: 'campusName',
            align: 'center',
        },
        {
            title: t('class.class.column74'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
        },
        {
            title: '',
            key: 'memberName',
            align: 'center',
            width: '10px',
            render:(value,record) => {
                let isDefAppMember : boolean = false;
                if(FA0007) {
                    isDefAppMember = FA0007.some((item)=>item.detailCode === record.memberCode);
                }
                return (!isDefAppMember && 
                    <button type="button" className="btn-delete" style={{cursor:'pointer'}} 
                        onClick={()=>{delMember(selectedApprovalList,setSelectedApprovalList,record.memberCode)}} ></button>);
            }
        },
    ];

    const appCCLinecolumns: TableColumnsType<IApprovalLine> = [
        {
            title: t('campus.staff.column38'),
            dataIndex: 'campusName',
            key: 'campusName',
            align: 'center',
        },
        {
            title: t('class.class.column74'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
        },
        {
            title: '',
            key: 'memberName',
            align: 'center',
            width: '10px',
            render:(value,record) => {
                return (record.memberCode !== financialsDefCCMemCode && 
                    <button type="button" className="btn-delete" onClick={()=>{delMember(selectedCCList,setSelectedCCList,record.memberCode)}} ></button>);
            }
        },
    ];

    //Drag & Drop 처리
    const DraggableBodyRow = ({
        index,
        moveRow,
        className,
        style,
        ...restProps
        }: DraggableBodyRowProps) => {
        const ref = useRef<HTMLTableRowElement>(null);
        const [{isOver, dropClassName}, drop] = useDrop({
            accept: type,
            collect: monitor => {
                const {index: dragIndex} : any = monitor.getItem() || {};
                if(dragIndex === index) {
                    return {}
                }
                return {
                    isOver: monitor.isOver(),
                    dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
                };
            },
            drop: (item: { index: number }) => {
                moveRow(item.index, index);
            },
        });
        const [, drag] = useDrag({
            type,
            item: { index },
            collect: monitor => ({
                isDragging: monitor.isDragging(),
            })
        });
        (index+1===approvalListData.length)||drop(drag(ref));

        return (
            <tr
                ref={ref}
                className={`${className}${isOver ? dropClassName : ''}`}
                style={(index+1===approvalListData.length)?{cursor: 'no-drop', ...style}:{ cursor: 'grab', ...style }}
                {...restProps}
            />

        );
    };

    const components = {
        body: {
            row: DraggableBodyRow,
        }
    };

    const moveRow = useCallback(
        (dragIndex: number, hoverIndex: number) => {
            const dragRow = approvalListData[dragIndex];
            const tempData = update(approvalListData, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, dragRow],
                ],
            });

            let tempNo = 1;
            const tempSelData : Map<string, IEmployeeValue> = new Map<string, IEmployeeValue>();
            tempData.forEach((item: IApprovalLine) => {
                item.orderSeq = tempNo;
                tempNo++;
                tempSelData.set(item.memberCode, {campusCode:item.campusCode, campusName:item.campusName, memberName:item.memberName});
            });

            setApprovalListData(tempData);
            setSelectedApprovalList(tempSelData);
        },
        [approvalListData],
    );

    return(
        <>
            <ErrorResponse error={error} />
            {/*
            <div className="comm-bx__between">  
                <h3 className='sub-title'>{t('payment.income.title1')}</h3>
            </div>
            */}
            <div className="w-100 flex">
                <div className="w-50">
                    <div className="comm-bx__between"> 
                        <div><h3 className="sub-title">{t('payment.expense.title1')}</h3></div>
                        <div className="comm-btn__area">
                            <Button
                                onClick={()=>{setVisibleApprovalLineModal(true)}}
                                className="btn-basic pink-line"
                                text={t('campus.shuttle.button2')}
                                /*writeAuthYn={writeAuthYn}*/
                            />
                        </div>
                    </div>
                    <div className="comm-table__area">
                        <DndProvider backend={HTML5Backend}>
                            <Table 
                                className='approvalLineTable'
                                columns={appLinecolumns}
                                dataSource={approvalListData}
                                components={components}
                                onRow={(_, index) => {
                                    const attr = {
                                        index,
                                        moveRow,
                                    };
                                    return attr as React.HTMLAttributes<any>;
                                }}
                                rowKey={'memberCode'}
                                pagination={{
                                    current: 1,
                                    pageSize: 999999999,
                                }}
                            />
                        </DndProvider>
                    </div>
                </div>
                <div className="w-50 ml-2">
                    <div className="comm-bx__between"> 
                        <div><h3 className="sub-title">{t('payment.expense.title2')}</h3></div>
                        <div className="comm-btn__area">
                            <Button
                                onClick={()=>{setVisibleCCLineModal(true)}}
                                className="btn-basic pink-line"
                                text={t('campus.shuttle.button2')}
                                /*writeAuthYn={writeAuthYn}*/
                            />
                        </div>
                    </div>
                    <div className="comm-table__area">
                        <Table 
                            columns={appCCLinecolumns}
                            dataSource={ccListData}
                            rowKey={'memberCode'}
                            pagination={{
                                current: 1,
                                pageSize: 999999999,
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="comm-bx__between">  
                <h3 className='sub-title'>{t('payment.expense.title4')}</h3>
            </div>
            <div className="comm-table__area rowType">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="85%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>{t('system.treecode.account1')}</th>
                            <td>
                                <Select
                                    placeholder={t('payment.income.search2') + ' ' + t('campus.staff.placeholder2')}
                                    className="w-240p"
                                    value={account1}
                                    onChange={(value)=>{
                                        firstAccountChange(value);
                                    }}
                                >
                                    {
                                        FA0001?.map((item : ITreeCode)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode.toString()}
                                                    value={item.detailCode.toString()}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('system.treecode.account2')}</th>
                            <td>
                                <Select
                                    placeholder={t('payment.income.search2') + ' ' + t('campus.staff.placeholder2')}
                                    className="w-240p"
                                    value={account2}
                                    onChange={(value)=>{
                                        secondAccountChange(value);
                                    }}
                                >
                                    {
                                        account2List?.map((item : ITreeCode)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode.toString()}
                                                    value={item.detailCode.toString()}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('system.treecode.account3')}</th>
                            <td>
                                <Select
                                    placeholder={t('payment.income.search2') + ' ' + t('campus.staff.placeholder2')}
                                    className="w-240p"
                                    value={account3}
                                    onChange={(value)=>{
                                        setAccount3(value);
                                    }}
                                >
                                    {
                                        account3List?.map((item : ITreeCode)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode.toString()}
                                                    value={item.detailCode.toString()}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div ref={dateArea} ></div>
            <div className="comm-table__area rowType">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="35%" />
                        <col width="15%" />
                        <col width="35%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>{t('student.student.62')}</th>
                            <td>{registDate.format('YYYY-MM-DD')}</td>
                            <th>{'* ' + t('payment.expense.column1')}</th>
                            <td>
                                <div className="date-picker__area">
                                    <DatePicker
                                        value={expenseDate ? moment(expenseDate) : undefined}
                                        onChange={e => {
                                            if (e === null) setExpenseDate('');
                                            else setExpenseDate(moment(e).format('YYYYMMDD'))
                                        }}
                                        format={['YYYY-MM-DD', 'YYYYMMDD']}
                                        getPopupContainer={() => {
                                            return dateArea.current as HTMLElement;
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{'* ' + t('common.column.title')}</th>
                            <td colSpan={3}>
                                <div className="w-100">
                                    <input
                                        type="text"
                                        className="form-control input-text"
                                        value={title}
                                        onChange={e => setTitle(e.target.value)}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.expense.label6')}</th>
                            <td colSpan={3}>
                                <div className="w-100">
                                    <textarea
                                        className="w-100"
                                        rows={5}
                                        value={summary}
                                        onChange={(e) => setSummary(e.target.value)}
                                        maxLength={1500}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{'* ' + t('payment.expense.column4')}</th>
                            <td>
                                <Select
                                    className="w-100"
                                    value={expenseMtd}
                                    onChange={(value)=>{
                                        setExpenseMtd(value);
                                    }}
                                >
                                    {
                                        FA0002?.map((item)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode}
                                                    value={item.detailCode}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                            <th>{'* ' + t('payment.expense.label5')}</th>
                            <td>
                                <Select
                                    className="w-100"
                                    value={expenseYn}
                                    onChange={(value)=>{
                                        setExpenseYn(value);
                                    }}
                                >
                                    {
                                        FA0003?.map((item)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode}
                                                    value={item.detailCode}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <th>{'* ' + t('entrance.schedule.column29')}</th>
                            <td colSpan={3}>
                                <div className="flex" style={{alignItems:'center', gap:'5px'}}>
                                    <Select
                                        className="w-120p text-center"
                                        value={currency}
                                        onChange={(value)=>{
                                            setCurrency(value);
                                        }}
                                    >   
                                        {FB0004?.map((item) => {
                                            return(
                                                <Select.Option
                                                    key={item.detailCode}
                                                    value={item.detailCode}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })};
                                    </Select>
                                    <input
                                        type="number"
                                        className="form-control input-text text-right w-210p"
                                        value={amount.toString()}
                                        onChange={e => {
                                            if(Number(e.target.value) < 0) {
                                                return false;
                                            }
                                            setAmount(Number(e.target.value))
                                        }}
                                    />
                                    <b>{t('campus.setting.text2')}</b>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.expense.label4')}</th>
                            <td colSpan={3}>
                                <div className="comm-btn__area">
                                    <input
                                        type="text"
                                        className="form-control input-text w-240p"
                                        value={clientName}
                                        onChange={e => setClientName(e.target.value)}
                                    /> 
                                    <Button
                                        className="btn-basic mint-line"
                                        onClick={()=>{setVisibleClientModal(true)}} 
                                        text={t('payment.expense.btn1')}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.expense.column6')}</th>
                            <td>
                                <div className="w-100">
                                    <input
                                        type="text"
                                        className="form-control input-text"
                                        value={clientDepositor}
                                        onChange={e => setClientDepositor(e.target.value)}
                                    />
                                </div>
                            </td>
                            <th>{t('homepage.member.20')}</th>
                            <td>
                                <div className="w-100">
                                    <input
                                        type="text"
                                        className="form-control input-text"
                                        value={clientTelNo}
                                        onChange={e => setClientTelNo(e.target.value)}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('campus.shuttle.column12')}</th>
                            <td>
                                <Select
                                    className="w-100 text-center"
                                    value={clientBankCode}
                                    onChange={(value)=>{
                                        setClientBankCode(value);
                                    }}
                                    placeholder={t('statistics.regularTest.placeholder2')}
                                >   
                                    {SY0007?.map((item) => {
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                                {i18n.language === 'ko' ? item.korName : item.engName}
                                            </Select.Option>
                                        );
                                    })};
                                </Select>
                            </td>
                            <th>{t('campus.shuttle.column13')}</th>
                            <td>
                                <div className="w-100">
                                    <input
                                        type="text"
                                        className="form-control input-text"
                                        value={clientAccNo}
                                        onChange={e => setClientAccNo(e.target.value)}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.expense.label2')}</th>
                            <td>
                                <Select
                                    className="w-100"
                                    value={proofType}
                                    onChange={(value)=>{
                                        setProofType(value);
                                    }}
                                >
                                    {
                                        FA0004?.map((item)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode}
                                                    value={item.detailCode}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                            <th>{'* ' + t('payment.expense.label3')}</th>
                            <td>
                                <div className="date-picker__area">
                                    <DatePicker
                                        value={proofDate ? moment(proofDate) : undefined}
                                        onChange={e => {
                                            if (e === null) setProofDate('');
                                            else setProofDate(moment(e).format('YYYYMMDD'))
                                        }}
                                        format={['YYYY-MM-DD', 'YYYYMMDD']}
                                        getPopupContainer={() => {
                                            return dateArea.current as HTMLElement;
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>
                        
                        <tr>
                            <th>{t('common.column.file')}</th>
                            <td colSpan={3}>
                                {files.map((file: any, index: number) => (
                                    <div className="flex mb-2" key={index}>
                                        <FileUpload
                                        file={files[index]}
                                        setFile={(file: any) => onSetFile(index, file)}
                                        />
                                        <div className="comm-btn__area">
                                            <Button
                                                className="btn-basic small gray ml-2"
                                                onClick={() => onDeleteFile(index)}
                                                text={t('common.button.delete')}
                                            />
                                        </div>
                                    </div>
                                ))}
                                <div className="comm-btn__area">
                                    <Button
                                        className="btn-basic pink-line"
                                        onClick={onAddFile}
                                        text={t('common.button.add')}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('common.text.note')}</th>
                            <td colSpan={3}>
                                <textarea
                                    className="w-100"
                                    rows={2}
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                    maxLength={299}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="comm-bx__between">
                <div></div>
                <div className="comm-btn__area">
                    <Button
                        onClick={onSave}
                        className="btn-basic pink"
                        text={t('common.button.save')}
                        /*writeAuthYn={writeAuthYn}*/
                    />
                </div>
            </div>
            {vislbleClientModal && (
                <ClientManageModal
                    visible={vislbleClientModal}
                    setVisible={setVisibleClientModal}
                    setClientInfo={fnSetClientInfo}
                />
            )}
            {visibleApprovalLineModal && (
                <ApprovalLineModal
                    visible={visibleApprovalLineModal}
                    setVisible={setVisibleApprovalLineModal}
                    selectedMemberList={selectedApprovalList}
                    setSelectedMemberList={setSelectedApprovalList}
                    defaultLine={FA0007}
                    alType={ApprovalLineType.APPROVAL_LINE}
                    pCampusCode={currentCampus}
                />
            )}
            {visibleCCLineModal && (
                <CCLineModal
                    visible={visibleCCLineModal}
                    setVisible={setVisibleCCLineModal}
                    selectedMemberList={selectedCCList}
                    setSelectedMemberList={setSelectedCCList}
                    defaultLine={FA0008}
                    alType={ApprovalLineType.CC_LINE}
                    pCampusCode={currentCampus}
                />
            )}
        </>
    )
}

export default ExpenseCopy;